/**
 * Tag
 * Uniquely tag a function. This is used to identify actions
 */

'use strict';

exports.__esModule = true;
exports['default'] = tag;
var uid = 0;

function tag(fn, name) {
  if (process.env.NODE_ENV !== 'production' && typeof fn !== 'function') {
    throw TypeError('Attempted to tag an action, but the provided value is not a function. Instead got ' + typeof fn);
  }

  /**
   * Respect existing toString methods.
   */
  if (fn.hasOwnProperty('toString')) {
    return fn;
  }

  /**
   * Auto-increment a stepper suffix to prevent two actions with the
   * same name from colliding.
   */
  var suffix = uid++;

  /**
   * Function.name lacks legacy support. For these browsers, fallback
   * to a consistent name:
   */
  var symbol = name || (fn.name || 'microcosm_action') + '_' + suffix;

  fn.toString = function () {
    return symbol;
  };

  return fn;
}

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy90YWcuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7cUJBT3dCLEdBQUc7QUFGM0IsSUFBSSxHQUFHLEdBQUcsQ0FBQyxDQUFBOztBQUVJLFNBQVMsR0FBRyxDQUFFLEVBQUUsRUFBRSxJQUFJLEVBQUU7QUFDckMsTUFBSSxPQUFPLENBQUMsR0FBRyxDQUFDLFFBQVEsS0FBSyxZQUFZLElBQUssT0FBTyxFQUFFLEtBQUssVUFBVSxBQUFDLEVBQUU7QUFDdkUsVUFBTSxTQUFTLENBQUMsb0ZBQW9GLEdBQUcsT0FBTyxFQUFFLENBQUMsQ0FBQTtHQUNsSDs7Ozs7QUFLRCxNQUFJLEVBQUUsQ0FBQyxjQUFjLENBQUMsVUFBVSxDQUFDLEVBQUU7QUFDakMsV0FBTyxFQUFFLENBQUE7R0FDVjs7Ozs7O0FBTUQsTUFBSSxNQUFNLEdBQUcsR0FBRyxFQUFFLENBQUE7Ozs7OztBQU1sQixNQUFJLE1BQU0sR0FBRyxJQUFJLElBQUksQ0FBQyxFQUFFLENBQUMsSUFBSSxJQUFJLGtCQUFrQixDQUFBLEdBQUksR0FBRyxHQUFHLE1BQU0sQ0FBQTs7QUFFbkUsSUFBRSxDQUFDLFFBQVEsR0FBRztXQUFNLE1BQU07R0FBQSxDQUFBOztBQUUxQixTQUFPLEVBQUUsQ0FBQTtDQUNWIiwiZmlsZSI6InNyYy90YWcuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIFRhZ1xuICogVW5pcXVlbHkgdGFnIGEgZnVuY3Rpb24uIFRoaXMgaXMgdXNlZCB0byBpZGVudGlmeSBhY3Rpb25zXG4gKi9cblxubGV0IHVpZCA9IDBcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdGFnIChmbiwgbmFtZSkge1xuICBpZiAocHJvY2Vzcy5lbnYuTk9ERV9FTlYgIT09ICdwcm9kdWN0aW9uJyAmJiAodHlwZW9mIGZuICE9PSAnZnVuY3Rpb24nKSkge1xuICAgIHRocm93IFR5cGVFcnJvcignQXR0ZW1wdGVkIHRvIHRhZyBhbiBhY3Rpb24sIGJ1dCB0aGUgcHJvdmlkZWQgdmFsdWUgaXMgbm90IGEgZnVuY3Rpb24uIEluc3RlYWQgZ290ICcgKyB0eXBlb2YgZm4pXG4gIH1cblxuICAvKipcbiAgICogUmVzcGVjdCBleGlzdGluZyB0b1N0cmluZyBtZXRob2RzLlxuICAgKi9cbiAgaWYgKGZuLmhhc093blByb3BlcnR5KCd0b1N0cmluZycpKSB7XG4gICAgcmV0dXJuIGZuXG4gIH1cblxuICAvKipcbiAgICogQXV0by1pbmNyZW1lbnQgYSBzdGVwcGVyIHN1ZmZpeCB0byBwcmV2ZW50IHR3byBhY3Rpb25zIHdpdGggdGhlXG4gICAqIHNhbWUgbmFtZSBmcm9tIGNvbGxpZGluZy5cbiAgICovXG4gIHZhciBzdWZmaXggPSB1aWQrK1xuXG4gIC8qKlxuICAgKiBGdW5jdGlvbi5uYW1lIGxhY2tzIGxlZ2FjeSBzdXBwb3J0LiBGb3IgdGhlc2UgYnJvd3NlcnMsIGZhbGxiYWNrXG4gICAqIHRvIGEgY29uc2lzdGVudCBuYW1lOlxuICAgKi9cbiAgdmFyIHN5bWJvbCA9IG5hbWUgfHwgKGZuLm5hbWUgfHwgJ21pY3JvY29zbV9hY3Rpb24nKSArICdfJyArIHN1ZmZpeFxuXG4gIGZuLnRvU3RyaW5nID0gKCkgPT4gc3ltYm9sXG5cbiAgcmV0dXJuIGZuXG59XG4iXX0=




/*****************
 ** WEBPACK FOOTER
 ** ./~/microcosm/tag.js
 ** module id = 93
 ** module chunks = 0
 **/